//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { User } from 'oidc-client-ts';
export class BaseApiClient {
    /**
     * Base class for all generated nswag clients.
     *
     * If something is changed in this file the clients will need to be re-generated using the nswag cli.
     *
     * The comment is placed inside the class as nswag will place it at the end of all generated api files if moved
     * above the class declaration.
     */

    /** The locale to set as the Accept-Language header */
    public locale: string | null = null;

    /** The authorization header to set */
    public authorization: string | null = null;

    /** Sets the credentials options of the fetch request */
    public credentials: RequestCredentials | null = null;

    /**
     * Sets the authorization header from a user object.
     */
    public setAuthorizationFromUser(user: User): void {
        this.authorization = `${user.token_type} ${user.access_token}`;
    }

    /**
     * Transforms the request options right before sending the api request.
     */
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = new Headers(options.headers);

        if (this.locale) {
            headers.set('Accept-Language', this.locale);
        }

        if (this.authorization) {
            headers.set('Authorization', this.authorization);
        }

        const credentials = this.credentials ?? undefined;

        return { ...options, headers, credentials };
    }
}

export class AuthenticationIdentityApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the login status of the current user.
     * @return No Content
     */
    authentication(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Authentication";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthentication(_response);
        });
    }

    protected processAuthentication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Authenticate a user with username and password.
     * @param body The authentication model.
     * @return No Content
     */
    login(body: LoginCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Authentication/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserIdentityApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Sends a password reset email for the given email.
     * @param body The reset password model.
     */
    forgotPassword(body: ResetPasswordModel, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reset password for a user.
     * @param body The password reset model.
     * @return OK
     */
    resetPassword(body: ResetPasswordCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/User/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the login status for the user.
     * @param email The user email to get the status for.
     * @return OK
     */
    status(email: string, signal?: AbortSignal): Promise<UserAccountStatusModel> {
        let url_ = this.baseUrl + "/api/User/status?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<UserAccountStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccountStatusModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccountStatusModel>(null as any);
    }

    /**
     * Send a new confirmation email for the currently authenticated user.
     */
    sendConfirmation(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/email/send-confirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendConfirmation(_response);
        });
    }

    protected processSendConfirmation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Complete the email confirmation for the user.
     * @param userId The id of the user to complete the confirmation for.
     * @param code The email confirmation code.
     */
    confirm(userId: string, code: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/email/confirm/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirm(_response);
        });
    }

    protected processConfirm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Authenticates a user. */
export class LoginCommand implements ILoginCommand {
    /** The user email address. */
    email!: string;
    /** The password for the user. */
    password!: string;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

/** Authenticates a user. */
export interface ILoginCommand {
    /** The user email address. */
    email: string;
    /** The password for the user. */
    password: string;
}

/** The account status for a user. */
export class UserAccountStatusModel implements IUserAccountStatusModel {
    /** The next step that the user should perform to authenticate. */
    nextStep!: UserAuthenticationStep;

    constructor(data?: IUserAccountStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextStep = _data["nextStep"] !== undefined ? _data["nextStep"] : <any>null;
        }
    }

    static fromJS(data: any): UserAccountStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextStep"] = this.nextStep !== undefined ? this.nextStep : <any>null;
        return data;
    }
}

/** The account status for a user. */
export interface IUserAccountStatusModel {
    /** The next step that the user should perform to authenticate. */
    nextStep: UserAuthenticationStep;
}

/** The next step for a user during authentication. */
export enum UserAuthenticationStep {
    Signup = "Signup",
    ResetPassword = "ResetPassword",
    Continue = "Continue",
}

/** A DTO for exceptions. */
export class ErrorDto implements IErrorDto {
    /** The type of exception (type name). */
    readonly exceptionType!: string | null;
    /** The error code, may be a number, guid or string. */
    code!: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    readonly errors!: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responseCode!: number;
    /** The error message. */
    message!: string | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace!: string | null;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).exceptionType = _data["exceptionType"] !== undefined ? _data["exceptionType"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            if (_data["errors"]) {
                (<any>this).errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>(<any>this).errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : <any>null;
                }
            }
            else {
                (<any>this).errors = <any>null;
            }
            this.responseCode = _data["responseCode"] !== undefined ? _data["responseCode"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        data["responseCode"] = this.responseCode !== undefined ? this.responseCode : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        return data;
    }
}

/** A DTO for exceptions. */
export interface IErrorDto {
    /** The type of exception (type name). */
    exceptionType: string | null;
    /** The error code, may be a number, guid or string. */
    code: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    errors: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responseCode: number;
    /** The error message. */
    message: string | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace: string | null;
}

/** The intent that the user was redirected to the onboarding for. */
export enum LoginIntent {
    Default = "Default",
    Register = "Register",
    Booking = "Booking",
    Shop = "Shop",
    RedeemPass = "RedeemPass",
    ConnectSerialTicket = "ConnectSerialTicket",
    SignOut = "SignOut",
}

/** Query parameters for the password reset return url. If not set the default values are used. */
export class OnboardingStateModel implements IOnboardingStateModel {
    /** Intent for the return url. If none is set the default one will be used. E.g. "default", "register", handled in the onboarding. */
    intent!: LoginIntent;
    /** Optional origin for the return url. If none is set the default one will be used. E.g. "entranceBooking", "partyBooking", handled in the onboarding. */
    origin!: ReturnOrigin;
    /** The continue path to pass on with the code url. */
    continuePath!: string | null;

    constructor(data?: IOnboardingStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intent = _data["intent"] !== undefined ? _data["intent"] : <any>null;
            this.origin = _data["origin"] !== undefined ? _data["origin"] : <any>null;
            this.continuePath = _data["continuePath"] !== undefined ? _data["continuePath"] : <any>null;
        }
    }

    static fromJS(data: any): OnboardingStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intent"] = this.intent !== undefined ? this.intent : <any>null;
        data["origin"] = this.origin !== undefined ? this.origin : <any>null;
        data["continuePath"] = this.continuePath !== undefined ? this.continuePath : <any>null;
        return data;
    }
}

/** Query parameters for the password reset return url. If not set the default values are used. */
export interface IOnboardingStateModel {
    /** Intent for the return url. If none is set the default one will be used. E.g. "default", "register", handled in the onboarding. */
    intent: LoginIntent;
    /** Optional origin for the return url. If none is set the default one will be used. E.g. "entranceBooking", "partyBooking", handled in the onboarding. */
    origin: ReturnOrigin;
    /** The continue path to pass on with the code url. */
    continuePath: string | null;
}

/** Origins pages for the onboarding. Where the user came from. */
export enum ReturnOrigin {
    None = "None",
    Site = "Site",
    PartyBooking = "PartyBooking",
    EntranceBooking = "EntranceBooking",
    StartPage = "StartPage",
    MyAccount = "MyAccount",
    IdServer = "IdServer",
}

/** Command for resetting the password for a user. */
export class ResetPasswordCommand implements IResetPasswordCommand {
    /** The id of the user. */
    userId!: string;
    /** The password reset code that was sent by email. */
    code!: string;
    /** The new password for the user. */
    password!: string;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

/** Command for resetting the password for a user. */
export interface IResetPasswordCommand {
    /** The id of the user. */
    userId: string;
    /** The password reset code that was sent by email. */
    code: string;
    /** The new password for the user. */
    password: string;
}

/** Model for resetting the password for a given user. */
export class ResetPasswordModel implements IResetPasswordModel {
    /** The email to send the password reset for. */
    email!: string;
    /** Query parameters to add to the reset url. */
    onboardingState!: OnboardingStateModel | null;
    /** Optional culture for the reset url.
E.g. "sv-SE". */
    culture!: string | null;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.onboardingState = _data["onboardingState"] ? OnboardingStateModel.fromJS(_data["onboardingState"]) : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["onboardingState"] = this.onboardingState ? this.onboardingState.toJSON() : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        return data;
    }
}

/** Model for resetting the password for a given user. */
export interface IResetPasswordModel {
    /** The email to send the password reset for. */
    email: string;
    /** Query parameters to add to the reset url. */
    onboardingState: OnboardingStateModel | null;
    /** Optional culture for the reset url.
E.g. "sv-SE". */
    culture: string | null;
}

export class SwaggerIdentityApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerIdentityApiException = true;

    static isSwaggerIdentityApiException(obj: any): obj is SwaggerIdentityApiException {
        return obj.isSwaggerIdentityApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerIdentityApiException(message, status, response, headers, result);
}